const debug = () => {
  if (process.env.mode !== 'production' || window.location.search.includes('debug')) {
    try {
      import('eruda').then(({ default: eruda }) => {
        // const eruda = require('eruda');
        eruda.init({
          tool: ['console', 'network', 'resources', 'info', 'snippets', 'settings'],
          defaults: {
            transparency: 0.8,
          },
        });
      });
    } catch (e) {
      console.log(e);
    }
  }
};

export default debug;
